<template>
  <div v-if="currentSession || currentSession.video" class="tw-mt-12">
    <div class="section-block no-border is-column">
      <span class="title is-paddingless is-marginless"
        >THIS WEEKS GROUP SESSION</span
      >
      <small>{{ currentSession.scheduleDate }}</small>
    </div>
    <div class="columns tw-mt-4">
      <div class="column is-two-fifths">
        <figure class="image is-4x3">
          <img
            class="session-cover"
            v-lazy="currentSession.video.resource.cover.url"
          />
        </figure>
      </div>
      <div class="column session-info">
        <div>
          <p
            class="is-marginless is-size-2 has-text-weight-bold has-text-black session-title"
          >
            {{ currentSession.video.title }}
          </p>
          <p class="is-size-5 tw-mt-2">
            {{ currentSession.video.description }}
          </p>
        </div>
        <div class="action">
          <router-link
            class="button is-primary"
            :to="{
              name: 'resources.course',
              params: {
                slug: currentSession.video.resource.slug,
                course: currentSession.video.slug
              }
            }"
          >
            View lesson
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      currentGroup: state => state.group.currentGroup
    }),
    currentSession() {
      return this.currentGroup.current_session
    }
  }
}
</script>
